exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".travels-container {\n  font-size: 14px;\n  line-height: 20px;\n  font-family: 'SFUIText-Regular'; }\n\n.travels-container-content {\n  padding-bottom: 20%; }\n\n.travels-photo img {\n  width: 100%; }\n\n.travels-description-content {\n  padding: 10px; }\n\n.travels-description {\n  padding-bottom: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Travels/Home/HomeView.scss
// module id = 302
// module chunks = 0